import React from 'react';
import { Helmet } from 'react-helmet';

const Meta = ({ title, description, keywords }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keyword" content={keywords} />
    </Helmet>
  );
};

Meta.defaultProps = {
  title: 'Welcome To Irio Hub',
  description: 'We serve the tastiest meals at affordable prices',
  keywords: 'Breakfast, Meals ,Desserts, snacks and drinks',
};

export default Meta;
